import type { FC } from "react";
import { ArrowNext, BankNote01, Coins03, Link03, Send01, Share07, Ticket01, TrendUp01, Wallet02 } from "@untitledui/icons";
import type { SuggestedActionKey, SuggestedActionView } from "@mfa-aff/shared";
import { IconChip, LatinRuns } from "@mfa-aff/ui";
import { Button } from "@mfa-aff/ui/components/base/buttons/button";

const ICON: Record<SuggestedActionKey, FC<{ className?: string }>> = {
    add_sheba: BankNote01,
    fix_sheba: BankNote01,
    create_code: Ticket01,
    first_share: Send01,
    share_kit: Share07,
    request_payout: Wallet02,
    push_level: TrendUp01,
    keep_going: Link03,
};

/** Exactly one suggested next step, chosen by the server by priority (design doc §11, §14.6.4). */
export const SuggestedAction = ({ action: a }: { action: SuggestedActionView }) => {
    const action = { icon: ICON[a.key] ?? Coins03, title: a.title, body: a.description, cta: a.cta.label, href: a.cta.href };

    return (
        <section
            className="flex flex-col gap-4 rounded-2xl bg-brand-primary_alt bg-brand-soft p-5 shadow-xs ring-1 ring-brand-200 ring-inset md:flex-row md:items-center md:gap-5 md:p-6 dark:bg-brand-500/10 dark:ring-brand-500/25"
            aria-labelledby="suggested-title"
        >
            <div className="flex min-w-0 flex-1 items-start gap-3 md:gap-4">
                <IconChip icon={action.icon} color="brand" className="bg-brand-solid text-white dark:bg-brand-500 dark:text-white" />
                <div className="flex min-w-0 flex-col gap-1">
                    <p className="text-xs font-semibold text-brand-secondary dark:text-brand-300">پیشنهاد امروز</p>
                    <h2 id="suggested-title" className="text-md font-semibold text-primary">
                        <LatinRuns text={action.title} />
                    </h2>
                    <p className="text-sm text-tertiary">
                        <LatinRuns text={action.body} />
                    </p>
                </div>
            </div>
            <Button href={action.href} color="primary" size="md" iconTrailing={ArrowNext} className="shrink-0 max-md:w-full">
                {action.cta}
            </Button>
        </section>
    );
};
